<template>
  <div class="tile" :style="{
        width: 'calc(' + this.width + '% - 20px)',
        opacity: opacityTile
    }" :class="animatedClasses">
    {{tile_style}}
    <div class="tile_header">
      <i :class="'fal fa-' + icon" v-if="icon" style="margin-right: 10px;" @click="editTile" v-tooltip="tooltip"></i>
      <span>{{ title }}</span>
    </div>
    <div class="tile_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      animatedClasses: "",
      opacityTile: 0
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    path: {
      type: String,
      required: true
    },
    order: {
      type: Number,
      required: false
    },
    rules: {
      type: Array,
      required: false,
      default: undefined
    },
    tileId: {
      type: Number,
      required: false
    },
    width: {
      type: Number,
      default: 100
    },
    startUpAnimation: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tooltip() {
      if(this.path === undefined) {
        return "";
      }
      return '<b>Module: </b>' + this.path + '<br><b>Rules: </b>' + this.rulesDisplay;
    },
    rulesDisplay() {
      if(this.rules === undefined || this.rules === "" || this.rules.length === 0) {
        return "No rules";
      }
      var rules = "";
      this.rules.forEach(function(rule) {
        switch (rule.type) {
          case "time":
            rules += "Time: " + (rule.time.from + "").padStart(2, "0") + ":00 - " + (rule.time.to + "").padStart(2, "0") + ":00<br>";
            break;
          case "location":
            rules += "Location: " + rule.location.lat + ", " + rule.location.lon + " | Radius: " + rule.location.radius + " km<br>";
            break;
        }
      });
      return "<br>" + rules.substring(0, rules.length - 4);
    }
  },
  mounted() {
    if(this.startUpAnimation) {
      setTimeout(function () {
        this.animatedClasses = "animated fadeInDown";
        this.opacityTile = 1;
      }.bind(this), this.order * 100);
    } else {
      this.opacityTile = 1;
    }
    setTimeout(() => window.dispatchEvent(new Event('resize')), 2000);
  },
  methods: {
    editTile() {
      if(this.tileId !== undefined) {
        this.$router.push("/edit_tile/" + this.tileId);
      }
    }
  }
};
</script>

<style>
.tile {
  background: rgb(247, 247, 247);
  color: #07042b;

  text-align: center;
  padding: 0;
  border-radius: 10px;
  border: 1px solid transparent;
  margin: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,.3), 3px 5px 20px rgba(0,0,0,.2);
}

@media (prefers-color-scheme: dark) {
  .tile {
    background: #151515;
    color: #f7f7f7;
  }
}

.tile_header {
  background: transparent;
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  padding: 10px;
  border-radius: 12px 12px 0 0;
}

.tile_content {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}

@media only screen and (max-width: 900px) {
  .tile {
    width: calc(100% - 20px) !important;
  }
}
</style>